import React from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import { match } from 'assert';
import Select, { components } from 'react-select';

// Custom Option component with checkbox
const Option = ({ children, isSelected, innerProps, selectOption, data }) => {
    const handleChange = () => {
        selectOption(data);
    };
    
    return (
        <div
            style={{ backgroundColor: isSelected ? '#e6e6e6' : 'white' }}
            {...innerProps}
        >
            <div style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleChange}
                    style={{ marginRight: '8px' }}
                />
                <span onClick={handleChange} style={{ cursor: 'pointer' }}>
                    {children}
                </span>
            </div>
        </div>
    );
};

const DistrictUserCreation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    
    // KVK, State and District related
    const [kvkValue, setKvkValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState(null);
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [blockValue, setBlockValue] = useState([]);
    
    // Data arrays
    const [kvkData, setKvkData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [blockData, setBlockData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    
    // Validation and UI states
    const [isStateAutoSelected, setIsStateAutoSelected] = useState(false);
    const [isBlockAutoSelected, setIsBlockAutoSelected] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    
    // Tracking flags to prevent infinite loops
    const [isDistrictInitialized, setIsDistrictInitialized] = useState(false);
    const [isBlockInitialized, setIsBlockInitialized] = useState(false);

    // User role and available user types
    const [currentUserRole, setCurrentUserRole] = useState("");
    const [availableUserTypes, setAvailableUserTypes] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState("");

    useEffect(() => {
        // Get user type code for determining available user types
        const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
       // alert(userTypeCode);
        // Set current user role and determine available user types
        setCurrentUserRole(userTypeCode);
        
        // Determine which user types can be created based on current user's role
        const userTypes = [];
        
        // Only allow creating Surveyor users
        userTypes.push(
            { code: "5", name: "Surveyor" }
        );
        
        // Auto-select Surveyor since it's the only option
        setSelectedUserType("5");
        
        setAvailableUserTypes(userTypes);
        
        // If only one user type is available, select it by default
        if (userTypes.length === 1) {
            setSelectedUserType(userTypes[0].code);
        }

        fetchDesignation();
        fetchStates();
    }, []);

    // Auto-fill state based on session storage after states are loaded
    useEffect(() => {
        if (statesData.length > 0 && !state) {
            // Get state code and state name from session storage
            const sessionStateCode = sessionStorage.getItem("stateNameModel");
            const sessionStateName = sessionStorage.getItem("stateNameModel");
            const sessionDistrictCode = sessionStorage.getItem("districtCodeModel");
            const sessionDistrictName = sessionStorage.getItem("multiDistrict");
            
            console.log("Session Storage Values:", {
                stateCode: sessionStateCode,
                stateName: sessionStateName,
                districtCode: sessionDistrictCode,
                districtName: sessionDistrictName
            });
            
            if (sessionStateCode && sessionStateCode !== "0" && sessionStateCode !== "null") {
                console.log("Auto-filling state based on session storage. State Code:", sessionStateCode);
                
                // Find the matching state in the loaded states data
                let matchingState = statesData.find(stateItem => 
                    stateItem.stateCode === sessionStateCode || 
                    stateItem.stateCode === Number(sessionStateCode)
                );
                
                // If no match by code but we have a state name, try to find by name as fallback
                if (!matchingState && sessionStateName && sessionStateName !== "null") {
                    console.log("No match by code, trying to match by state name:", sessionStateName);
                    matchingState = statesData.find(stateItem => 
                        stateItem.stateName.toLowerCase() === sessionStateName.toLowerCase()
                    );
                }
                
                if (matchingState) {
                    console.log("Found matching state:", matchingState.stateName, "with code:", matchingState.stateCode);
                    setStateValue(matchingState.stateCode.toString());
                    setIsStateAutoSelected(true); // Mark state as auto-selected

                    // Update session storage with the correct values if needed
                    if (!sessionStorage.getItem("stateNameModel") || sessionStorage.getItem("stateNameModel") === "null") {
                        sessionStorage.setItem("stateNameModel", matchingState.stateName);
                        console.log("Updated session storage with state name:", matchingState.stateName);
                    }
                } else {
                    console.log("No matching state found for code:", sessionStateCode, "or name:", sessionStateName);
                }
            }
        }
    }, [statesData, state]);

    // Auto-fill district based on session storage after districts are loaded
    useEffect(() => {
        // Only run this once when districts are first loaded and not in edit mode
        if (districtsData.length > 0 && !isDistrictInitialized && !state) {
            // Try to get districts from multiDistrict first
            const multiDistrictStr = sessionStorage.getItem("multiDistrict");
            const sessionDistrictCode = sessionStorage.getItem("districtNameModel");
            const loginData = sessionStorage.getItem("loginData");
            
            let districtCodes = [];
            let districtNames = new Map(); // Store district names for reference
            
            // First try to get from loginData
            if (loginData) {
                try {
                    const parsedLoginData = JSON.parse(loginData);
                    if (parsedLoginData.districtCode) {
                        const codes = parsedLoginData.districtCode.toString().split(',');
                        districtCodes = codes.map(code => code.trim()).filter(code => code !== "");
                        console.log("Districts from loginData:", districtCodes);
                        
                        // If we have district names in loginData, store them
                        if (parsedLoginData.districtName) {
                            const names = parsedLoginData.districtName.split(',');
                            codes.forEach((code, index) => {
                                if (names[index]) {
                                    districtNames.set(code.trim(), names[index].trim());
                                }
                            });
                        }
                    }
                } catch (error) {
                    console.error("Error parsing loginData:", error);
                }
            }
            
            // If no districts found in loginData, try multiDistrict
            if (districtCodes.length === 0 && multiDistrictStr) {
                try {
                    const multiDistrict = JSON.parse(multiDistrictStr);
                    console.log("Multi-district data found:", multiDistrict);
                    
                    if (Array.isArray(multiDistrict)) {
                        districtCodes = [];
                        multiDistrict.forEach(district => {
                            if (district.districtCode) {
                                const code = district.districtCode.toString();
                                districtCodes.push(code);
                                if (district.districtName) {
                                    districtNames.set(code, district.districtName);
                                }
                            }
                        });
                        console.log("Districts from multiDistrict:", districtCodes);
                    }
                } catch (error) {
                    console.error("Error parsing multiDistrict:", error);
                }
            }
            
            // If still no districts found, try districtNameModel
            if (districtCodes.length === 0 && sessionDistrictCode && sessionDistrictCode !== "0" && sessionDistrictCode !== "null") {
                console.log("Using district codes from districtNameModel:", sessionDistrictCode);
                districtCodes = sessionDistrictCode.includes(',') ? 
                    sessionDistrictCode.split(',').map(code => code.trim()) : 
                    [sessionDistrictCode];
            }
            
            if (districtCodes.length > 0) {
                console.log("Final district codes to handle:", districtCodes);
                
                // Filter districts to only include the user's assigned districts
                // Handle both district codes (numeric) and district names (string)
                const filteredDistricts = districtsData.filter(district => {
                    // Check if it matches by code
                    if (districtCodes.includes(district.districtCode.toString())) {
                        return true;
                    }
                    // Check if it matches by name (case-insensitive)
                    if (districtCodes.some(code => 
                        code.toLowerCase() === district.districtName.toLowerCase()
                    )) {
                        return true;
                    }
                    return false;
                }).map(district => ({
                    ...district,
                    districtName: districtNames.get(district.districtCode.toString()) || district.districtName
                }));
                
                console.log("Filtered districts:", filteredDistricts);
                
                if (filteredDistricts.length > 0) {
                    // Set the filtered districts and selected values
                    setDistrictsData(filteredDistricts);
                    
                    // Auto-select only the first district (single-select behavior)
                    const firstDistrictCode = filteredDistricts[0].districtCode.toString();
                    setDistrictValue(firstDistrictCode);
                    setSelectedDistricts([firstDistrictCode]);
                    
                    // Fetch blocks for the first selected district
                    fetchBlocks(firstDistrictCode);
                    
                    // Mark as initialized to prevent re-running
                    setIsDistrictInitialized(true);
                } else {
                    console.warn("No matching districts found in the data");
                    setIsDistrictInitialized(true);
                }
            } else {
                // No district codes found, mark as initialized anyway
                setIsDistrictInitialized(true);
            }
        }
    }, [districtsData, isDistrictInitialized, state]);

    // Auto-fill block based on session storage after blocks are loaded
    useEffect(() => {
        if (blockData.length > 0 && !state && !isBlockInitialized) {
            // Get block code and block name from session storage
            const sessionBlockCode = sessionStorage.getItem("blockCodeModel");
            const sessionBlockName = sessionStorage.getItem("blockNameModel");
            
            console.log("Block Session Storage Values:", {
                blockCode: sessionBlockCode,
                blockName: sessionBlockName
            });
            
            if (sessionBlockCode && sessionBlockCode !== "0" && sessionBlockCode !== "null") {
                console.log("Auto-filling block based on session storage. Block Code:", sessionBlockCode);
                
                // Find the matching block in the loaded blocks data
                let matchingBlock = blockData.find(blockItem => 
                    blockItem.blockCode === sessionBlockCode || 
                    blockItem.blockCode === Number(sessionBlockCode)
                );
                
                // If no match by code but we have a block name, try to find by name as fallback
                if (!matchingBlock && sessionBlockName && sessionBlockName !== "null") {
                    console.log("No match by code, trying to match by block name:", sessionBlockName);
                    matchingBlock = blockData.find(blockItem => 
                        blockItem.blockName.toLowerCase() === sessionBlockName.toLowerCase()
                    );
                }
                
                if (matchingBlock) {
                    console.log("Found matching block:", matchingBlock.blockName, "with code:", matchingBlock.blockCode);
                    setBlockValue(matchingBlock.blockCode.toString());
                    setIsBlockAutoSelected(true); // Mark block as auto-selected

                    // Update session storage with the correct values if needed
                    if (!sessionStorage.getItem("blockNameModel") || sessionStorage.getItem("blockNameModel") === "null") {
                        sessionStorage.setItem("blockNameModel", matchingBlock.blockName);
                        console.log("Updated session storage with block name:", matchingBlock.blockName);
                    }
                } else {
                    console.log("No matching block found for code:", sessionBlockCode, "or name:", sessionBlockName);
                }
            }
            
            // Mark as initialized
            setIsBlockInitialized(true);
        }
    }, [blockData, state, isBlockInitialized]);

    // Validation functions
    const validateField = (fieldName, value) => {
        const errors = { ...validationErrors };
        
        switch (fieldName) {
            case 'userType':
                if (!value || value === "") {
                    errors.userType = "Please select a user type";
                } else {
                    delete errors.userType;
                }
                break;
                
            case 'state':
                if (!value || value === "NA" || value === "0") {
                    errors.state = "Please select a state";
                } else if (!statesData.some(state => state.stateCode.toString() === value.toString())) {
                    errors.state = "Please select a valid state";
                } else {
                    delete errors.state;
                }
                break;
                
            case 'district':
                if (!value || value === "" || value === "0") {
                    errors.district = "Please select a district";
                } else if (!districtsData.some(district => district.districtCode.toString() === value.toString())) {
                    errors.district = "Please select a valid district";
                } else {
                    delete errors.district;
                }
                break;
                
            case 'block':
                if (selectedUserType === "5") {
                    if (!value || !Array.isArray(value) || value.length === 0) {
                        errors.block = "Please select at least one block";
                    } else if (!value.every(block => blockData.some(b => b.blockCode.toString() === block.value.toString()))) {
                        errors.block = "Please select valid blocks";
                    } else {
                        delete errors.block;
                    }
                }
                break;
                
            case 'userName':
                if (!value || value.trim() === "") {
                    errors.userName = "Please enter a valid user name";
                } else if (value.trim().length < 3) {
                    errors.userName = "User name must be at least 3 characters long";
                } else if (value.trim().length > 50) {
                    errors.userName = "User name cannot exceed 50 characters";
                } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
                    errors.userName = "User name can only contain letters and spaces";
                } else {
                    delete errors.userName;
                }
                break;
                
            case 'designation':
                if (!value || value === "Choose..." || value === "") {
                    errors.designation = "Please select a designation";
                } else if (!designationData.some(desig => desig.desigCode.toString() === value.toString())) {
                    errors.designation = "Please select a valid designation";
                } else {
                    delete errors.designation;
                }
                break;
                
            case 'mobile':
                if (!value) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (value.length !== 10) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (!/^[6-9]\d{9}$/.test(value)) {
                    errors.mobile = "Please enter a valid Indian mobile number";
                } else {
                    delete errors.mobile;
                }
                break;
                
            case 'gender':
                if (!value) {
                    errors.gender = "Please select a gender";
                } else if (!["M", "F", "T"].includes(value)) {
                    errors.gender = "Please select a valid gender";
                } else {
                    delete errors.gender;
                }
                break;
                
            case 'email':
                if (!value || value.trim() === "") {
                    errors.email = "Please enter a valid email address";
                } else if (!validateEmail(value.trim())) {
                    errors.email = "Please enter a valid email address";
                } else if (value.trim().length > 100) {
                    errors.email = "Email cannot exceed 100 characters";
                } else {
                    delete errors.email;
                }
                break;
                
            case 'kvk':
                if (!value || value === "0" || value === "") {
                    errors.kvk = "Please select a KVK";
                } else if (!kvkData.some(kvk => kvk.kvkCode.toString() === value.toString())) {
                    errors.kvk = "Please select a valid KVK";
                } else {
                    delete errors.kvk;
                }
                break;
                
            default:
                break;
        }
        
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateAllFields = () => {
        const fieldsToValidate = [
            { name: 'userType', value: selectedUserType },
            { name: 'state', value: stateValue },
            { name: 'district', value: districtValue },
            { name: 'userName', value: userNameValue },
            { name: 'designation', value: designationValue },
            { name: 'mobile', value: mobileValue },
            { name: 'gender', value: gender },
            { name: 'email', value: emailValue.trim() }
        ];

        // Only validate block if creating a Surveyor user
        if (selectedUserType === "5") {
            fieldsToValidate.push({ name: 'block', value: blockValue });
        }
        
        let isValid = true;
        fieldsToValidate.forEach(field => {
            const fieldValid = validateField(field.name, field.value);
            if (!fieldValid) {
                isValid = false;
            }
        });

        // Additional validation
        if (!selectedUserType || selectedUserType === "") {
            alert("Please select a user type");
            return false;
        }
        
        return isValid;
    };

    useEffect(() => {
        if (stateValue && stateValue !== "NA") {
            console.log("State selected:", stateValue, "- Fetching districts...");
            fetchDistricts(stateValue);
        } else {
            console.log("No state selected or state is NA, clearing districts");
            setDistrictsData([]);
            setDistrictValue("");
            setBlockData([]);
            setBlockValue([]);
        }
    }, [stateValue]);

    useEffect(() => {
        if (districtValue && districtValue !== "NA") {
            console.log("District selected:", districtValue, "- Fetching blocks...");
            fetchBlocks(districtValue);
        } else {
            console.log("No district selected or district is NA, clearing blocks");
            setBlockData([]);
            setBlockValue([]);
        }
    }, [districtValue]);

    useEffect(() => {
        // useEffect to set defaultValue in dropdown menu for edit mode only
        // No auto-fill for new user creation - User Name must be entered manually
        if (state) {
            console.log("state$$$", state)
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile);
            setEmailValue(state.cropSurveyCode.emailId || "");
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender);
            setKvkValue(state.cropSurveyCode.kvkCode);
            setStateValue(state.cropSurveyCode.stateCode);
            setDistrictValue(state.cropSurveyCode.districtCode);
            setBlockValue(state.cropSurveyCode.blockCode);
        }
    }, []);

    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };
  

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            // Show all states
            const allStates = result.data.dataContent;
            console.log("All states:", allStates);
            setStatesData(allStates);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchKvkData = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/kvk`
            );
            setKvkData(result.data.dataContent || []);
        } catch (error) {
            console.error("Error fetching KVK data:", error);
            setKvkData([]);
        }
    };

    const fetchDistricts = async (stateCode) => {
        try {
            console.log("Fetching districts for state code:", stateCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: Number(stateCode),
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            console.log("Districts API response:", jsonResult);
            
            if (jsonResult && jsonResult.dataContent) {
                // Try to get districts from multiDistrict first
                const multiDistrictStr = sessionStorage.getItem("multiDistrict");
                let userDistricts = [];

                if (multiDistrictStr) {
                    try {
                        const multiDistrict = JSON.parse(multiDistrictStr);
                        if (Array.isArray(multiDistrict)) {
                            userDistricts = multiDistrict.map(district => district.districtCode?.toString() || "");
                        }
                    } catch (error) {
                        console.error("Error parsing multiDistrict:", error);
                    }
                }

                // If no districts found in multiDistrict, try districtNameModel
                if (userDistricts.length === 0) {
                    const sessionDistrictCode = sessionStorage.getItem("districtNameModel");
                    if (sessionDistrictCode && sessionDistrictCode !== "0" && sessionDistrictCode !== "null") {
                        userDistricts = sessionDistrictCode.includes(',') ? 
                            sessionDistrictCode.split(',').map(code => code.trim()) : 
                            [sessionDistrictCode];
                    }
                }

                console.log("User's district codes:", userDistricts);

                if (userDistricts.length > 0) {
                    // Filter districts to only include the user's districts
                    // Handle both district codes (numeric) and district names (string)
                    const filteredDistricts = jsonResult.dataContent.filter(district => {
                        // Check if it matches by code
                        if (userDistricts.includes(district.districtCode.toString())) {
                            return true;
                        }
                        // Check if it matches by name (case-insensitive)
                        if (userDistricts.some(userDist => 
                            userDist.toLowerCase() === district.districtName.toLowerCase()
                        )) {
                            return true;
                        }
                        return false;
                    });
                    console.log("Filtered districts:", filteredDistricts);
                    setDistrictsData(filteredDistricts);
                    
                    // Auto-select only the first district (single-select behavior)
                    const firstDistrictCode = filteredDistricts[0].districtCode.toString();
                    setDistrictValue(firstDistrictCode);
                    setSelectedDistricts([firstDistrictCode]);
                } else {
                    setDistrictsData(jsonResult.dataContent);
                }
                console.log("Districts set successfully:", jsonResult.dataContent.length, "districts");
            } else {
                console.log("No districts data received, setting empty array");
                setDistrictsData([]);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            // Don't break the component, just set empty districts
            setDistrictsData([]);
            alert("Error loading districts. Please try again.");
        }
    };

    const fetchBlocks = async (districtCode) => {
        try {
            if (!districtCode) {
                console.log("No district code provided");
                setBlockData([]);
                return;
            }

            console.log("Fetching blocks for district code:", districtCode);
            
            // Handle comma-separated district codes
            const districtCodes = districtCode.toString().includes(',') 
                ? districtCode.toString().split(',').map(code => code.trim())
                : [districtCode.toString()];

            console.log("Processing district codes:", districtCodes);

            // Fetch blocks for all districts in parallel
            const blockPromises = districtCodes.map(async (code) => {
                const numericDistrictCode = Number(code);
                if (isNaN(numericDistrictCode)) {
                    console.error("Invalid district code:", code);
                    return [];
                }

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                var raw = JSON.stringify({
                    districtCode: numericDistrictCode
                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };

                const apiUrl = `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/block`;

                try {
                    const response = await fetch(apiUrl, requestOptions);
                    
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    
                    const result = await response.text();
                    const jsonResult = JSON.parse(result);
                    
                    if (jsonResult && jsonResult.dataContent && Array.isArray(jsonResult.dataContent)) {
                        return jsonResult.dataContent;
                    }
                    return [];
                } catch (error) {
                    console.error(`Error fetching blocks for district ${code}:`, error);
                    return [];
                }
            });

            // Wait for all requests to complete
            const allBlocksArrays = await Promise.all(blockPromises);
            
            // Flatten and remove duplicates based on blockCode
            const allBlocks = allBlocksArrays.flat();
            const uniqueBlocks = allBlocks.reduce((acc, block) => {
                if (!acc.find(b => b.blockCode === block.blockCode)) {
                    acc.push(block);
                }
                return acc;
            }, []);

            console.log("All unique blocks fetched:", uniqueBlocks.length, "blocks");
            setBlockData(uniqueBlocks);
            
            // Clear block value when loading new blocks
            setBlockValue([]);
            
        } catch (error) {
            console.error("Error fetching blocks:", error);
            setBlockData([]);
            setBlockValue([]);
            alert("Error loading blocks. Please try again.");
        }
    };

    function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        
        try {
            // Clear previous validation errors
            setValidationErrors({});
            
            // Validate all fields and collect errors
            const fieldsToValidate = [
                { name: 'userType', value: selectedUserType },
                { name: 'state', value: stateValue },
                { name: 'district', value: districtValue },
                { name: 'userName', value: userNameValue },
                { name: 'designation', value: designationValue },
                { name: 'mobile', value: mobileValue },
                { name: 'gender', value: gender },
                { name: 'email', value: emailValue.trim() }
            ];

            // Only validate block if creating a Surveyor user
            if (selectedUserType === "5") {
                fieldsToValidate.push({ name: 'block', value: blockValue });
            }
            
            let errors = {};
            let isValid = true;
            
            fieldsToValidate.forEach(field => {
                const fieldErrors = validateFieldSync(field.name, field.value);
                if (Object.keys(fieldErrors).length > 0) {
                    errors = { ...errors, ...fieldErrors };
                    isValid = false;
                }
            });
            
            // Additional validation
            if (!selectedUserType || selectedUserType === "") {
                errors.userType = "Please select a user type";
                isValid = false;
            }
            
            // Update validation errors state
            setValidationErrors(errors);
            
            if (!isValid) {
                // Find the first error and show it
                const firstError = Object.values(errors)[0];
                if (firstError) {
                    alert(firstError);
                }
                return;
            }

            console.log("Validation successful, calling", state ? "UpdateUser" : "AddNewUser");
            state ? UpdateUser() : AddNewUser();
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation. Please check console for details.");
        }
    }

    function validateEmail(email) {
        // More comprehensive email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email.trim());
    }

    // Synchronous validation function that returns errors instead of updating state
    const validateFieldSync = (fieldName, value) => {
        const errors = {};
        
        switch (fieldName) {
            case 'userType':
                if (!value || value === "") {
                    errors.userType = "Please select a user type";
                }
                break;
                
            case 'state':
                if (!value || value === "NA" || value === "0") {
                    errors.state = "Please select a state";
                } else if (!statesData.some(state => state.stateCode.toString() === value.toString())) {
                    errors.state = "Please select a valid state";
                }
                break;
                
            case 'district':
                if (!value || value === "" || value === "0") {
                    errors.district = "Please select a district";
                } else if (!districtsData.some(district => district.districtCode.toString() === value.toString())) {
                    errors.district = "Please select a valid district";
                }
                break;
                
            case 'block':
                if (selectedUserType === "5") {
                    if (!value || !Array.isArray(value) || value.length === 0) {
                        errors.block = "Please select at least one block";
                    } else if (!value.every(block => blockData.some(b => b.blockCode.toString() === block.value.toString()))) {
                        errors.block = "Please select valid blocks";
                    }
                }
                break;
                
            case 'userName':
                if (!value || value.trim() === "") {
                    errors.userName = "Please enter a valid user name";
                } else if (value.trim().length < 3) {
                    errors.userName = "User name must be at least 3 characters long";
                } else if (value.trim().length > 50) {
                    errors.userName = "User name cannot exceed 50 characters";
                } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
                    errors.userName = "User name can only contain letters and spaces";
                }
                break;
                
            case 'designation':
                if (!value || value === "Choose..." || value === "") {
                    errors.designation = "Please select a designation";
                } else if (!designationData.some(desig => desig.desigCode.toString() === value.toString())) {
                    errors.designation = "Please select a valid designation";
                }
                break;
                
            case 'mobile':
                if (!value) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (value.length !== 10) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (!/^[6-9]\d{9}$/.test(value)) {
                    errors.mobile = "Please enter a valid Indian mobile number";
                }
                break;
                
            case 'gender':
                if (!value) {
                    errors.gender = "Please select a gender";
                } else if (!["M", "F", "T"].includes(value)) {
                    errors.gender = "Please select a valid gender";
                }
                break;
                
            case 'email':
                if (!value || value.trim() === "") {
                    errors.email = "Please enter a valid email address";
                } else if (!validateEmail(value.trim())) {
                    errors.email = "Please enter a valid email address";
                } else if (value.trim().length > 100) {
                    errors.email = "Email cannot exceed 100 characters";
                }
                break;
                
            default:
                break;
        }
        
        return errors;
    };

    function AddNewUser() {
        console.log("AddNewUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Create payload for district user
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "5", // Hardcoded for Surveyor
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": String(districtValue), // Single district code
                "subDistrictCode": "",
                "blockCode": Array.isArray(blockValue) ? blockValue.map(b => b.value).join(',') : "0",
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"), // User type from selection
                "schemeCode": "16", // You may need to adjust this based on requirements
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": kvkValue ? Number(kvkValue) : 0
            };
            
            console.log("API Payload:", payload);
            var raw = JSON.stringify(payload);

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

           
            
            fetch(
              `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    alert(jsonResult.message);
                    if (jsonResult.success === true) {
                        console.log("User created successfully, navigating to user list");
                        navigate("/MNT/UsrListMnt");
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Error communicating with server");
              });
        } catch (error) {
            console.error("Error in AddNewUser:", error);
            alert("An error occurred while creating user. Please check console for details.");
        }
    }
    const handleBlockChange = (selectedOptions) => {
        try {
            // Handle clearing the selection
            if (!selectedOptions) {
                setBlockValue([]);
                validateField('block', []);
                return;
            }

            // Ensure we have an array of selections
            const newValue = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
            
            console.log("Block selection changed:", newValue);
            
            // Update block value state
            setBlockValue(newValue);
            
            // Validate the selection
            validateField('block', newValue);
            
        } catch (error) {
            console.error("Error in handleBlockChange:", error);
            setBlockValue([]);
            validateField('block', []);
        }
    };
    function UpdateUser() {
        console.log("UpdateUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

             // Create payload for district user
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "5", // Hardcoded for Surveyor
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": String(districtValue), // Single district code
                "subDistrictCode": "",
                "blockCode": Array.isArray(blockValue) ? blockValue.map(b => b.value).join(',') : "0",
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"), // User type from selection
                "schemeCode": "16", // You may need to adjust this based on requirements
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": kvkValue ? Number(kvkValue) : 0
            };
            
            console.log("API Payload for update:", payload);
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            
            fetch(
              `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    alert(jsonResult.message);
                    if (jsonResult.success === true) {
                        console.log("District User updated successfully, navigating to user list");
                        navigate("/MNT/UsrListMnt");
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Error communicating with server");
              });
        } catch (error) {
            console.error("Error in UpdateUser:", error);
            alert("An error occurred while updating user. Please check console for details.");
        }
    }

    function handleUserName(e) {
      let localText = e.target.value.replace(/[^\w\s]/gi, "")
      console.log("Setting userName to:", localText);
      setUserNameValue(localText);
      validateField('userName', localText);
    }

    function handleEmail(e) {
        const emailValue = e.target.value;
        setEmailValue(emailValue);
        validateField('email', emailValue.trim());
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal);
        validateField('mobile', valueFinal);
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
        validateField('mobile', mobileValue);
    }

    // New handlers with validation
    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setStateValue(selectedState);
        validateField('state', selectedState);
    };

    const handleDesignationChange = (e) => {
        const selectedDesignation = e.target.value;
        setDesignationValue(selectedDesignation);
        validateField('designation', selectedDesignation);
    };

    const handleKvkChange = (e) => {
        const selectedKvk = e.target.value;
        setKvkValue(selectedKvk);
        validateField('kvk', selectedKvk);
    };

    const handleGenderChange = (selectedGender) => {
        setGender(selectedGender);
        validateField('gender', selectedGender);
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">User Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        default: return "";
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        
                                        
                                       
                                        
                                        {/* User Type */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Type</label><label style={{color : "red"}}>*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value="Surveyor"
                                                disabled
                                                style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                                            />
                                        </div>


                                        {/* State Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                            
                                            <select 
                                                className={`form-select ${validationErrors.state ? 'is-invalid' : ''}`}
                                                value={stateValue}
                                                onChange={handleStateChange}
                                                disabled={isStateAutoSelected}
                                                style={isStateAutoSelected ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                                            > 
                                                <option value={"NA"}>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {validationErrors.state && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.state}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* District Name */}
                                        <div className='col-md-4'>
                                            <div className="form-group">
                                                <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className={`form-select ${validationErrors.district ? 'is-invalid' : ''}`}
                                                    value={districtValue}
                                                    onChange={(e) => {
                                                        const selectedValue = e.target.value;
                                                        setDistrictValue(selectedValue);
                                                        setSelectedDistricts([selectedValue]);
                                                        validateField('district', selectedValue);
                                                        if (selectedValue) {
                                                            fetchBlocks(selectedValue);
                                                        } else {
                                                            setBlockData([]);
                                                            setBlockValue([]);
                                                        }
                                                    }}
                                                    disabled={districtsData.length === 1}
                                                    style={districtsData.length === 1 ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                                                >
                                                    <option value="">Choose...</option>
                                                    {districtsData.map((item, id) => (
                                                        <option key={id} value={item.districtCode}>
                                                            {item.districtName}
                                                        </option>
                                                    ))}
                                                </select>
                                            {validationErrors.district && !districtValue && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.district}
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                                {/* Block Name - Only show for Surveyor */}
                                        {selectedUserType === "5" && (
                                            <div className="col-md-4">
                                                <label htmlFor="block" className="form-label">
                                                  Block
                                                </label>
                                                <label style={{ color: "red" }}>*</label>
                                                <Select
                                                  id="block"
                                                  isMulti
                                                  className={`form-select ${validationErrors.block ? 'is-invalid' : ''}`}
                                                  value={blockValue}
                                                  onChange={handleBlockChange}
                                                  options={blockData.map(item => ({
                                                    value: item.blockCode.toString(),
                                                    label: item.blockName
                                                  }))}
                                                  isDisabled={isBlockAutoSelected || !districtValue}
                                                  placeholder="Select Blocks..."
                                                  closeMenuOnSelect={false}
                                                  hideSelectedOptions={false}
                                                  isSearchable={true}
                                                  isClearable={true}
                                                  components={{ Option }}
                                                />
                                                {validationErrors.block && (
                                                    <div className="invalid-feedback d-block">
                                                        {validationErrors.block}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        
                                        {/* KVK Code */}
                                        {/* <div className="col-md-4">
                                            <label htmlFor="kvk" className="form-label">
                                              KVK Code
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="kvk"
                                              required
                                              className={`form-select ${validationErrors.kvk ? 'is-invalid' : ''}`}
                                              onChange={handleKvkChange}
                                              value={kvkValue}
                                            >
                                              <option value="">Choose...</option>
                                              {kvkData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.kvkCode}>
                                                    {item.kvkName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                            {validationErrors.kvk && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.kvk}
                                                </div>
                                            )}
                                        </div> */}
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className={`form-control ${validationErrors.userName ? 'is-invalid' : ''}`}
                                                onChange={handleUserName} 
                                                value={userNameValue} 
                                                maxLength={50}
                                                autoComplete="off"

                                            />
                                            {validationErrors.userName && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.userName}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className={`form-select ${validationErrors.designation ? 'is-invalid' : ''}`}
                                              onChange={handleDesignationChange}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                            {validationErrors.designation && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.designation}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className={`form-control ${validationErrors.mobile ? 'is-invalid' : ''}`}
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                            />
                                            {validationErrors.mobile && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.mobile}
                                                </div>
                                            )}
                                        </div>
                                        {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label>
                                            <label style={{color : "red"}}>*</label>
                                            <input
                                              type="email"
                                              className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                                              id="emailId"
                                              placeholder="Email Id"
                                              onChange={handleEmail}
                                              value={emailValue}
                                            />
                                            {validationErrors.email && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.email}
                                                </div>
                                            )}
                                        </div>
                                        {/* Gender */}
                                        <div className="col-md-4">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className={`col-md-12 ${validationErrors.gender ? 'is-invalid' : ''}`}>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  handleGenderChange("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                  onChange={() => handleGenderChange("M")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                  onChange={() => handleGenderChange("F")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                  onChange={() => handleGenderChange("T")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                            {validationErrors.gender && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.gender}
                                                </div>
                                            )}
                                          </div>

                                        
                                    </div>
                                    
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update State User
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create User
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrListMnt")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
};
 
export default DistrictUserCreation; 